// Configuration centralisée pour les informations de contact
// Modifiez ces valeurs pour changer les informations dans tous les composants

export const CONTACT_CONFIG = {
  // Numéro de téléphone WhatsApp
  phoneNumber: "+32 460207686",
  
  // Email de contact
  email: "contact@tvportugal4k.com",
  
  // URL WhatsApp complète
  whatsappUrl: "https://wa.me/32460207686",
  
  // Nom de l'entreprise
  companyName: "TVPortugal4k",
  
  // URL du site web
  websiteUrl: "https://tvportugal4k.com"
};

// Fonction utilitaire pour formater le numéro de téléphone
export const formatPhoneNumber = (phoneNumber) => {
  return phoneNumber.replace(/\s/g, '');
};

// Fonction utilitaire pour créer l'URL WhatsApp
export const createWhatsAppUrl = (phoneNumber, message = "") => {
  const cleanNumber = formatPhoneNumber(phoneNumber);
  return `https://wa.me/${cleanNumber}${message ? `?text=${encodeURIComponent(message)}` : ''}`;
};
